module.exports = __webpack_public_path__ + "img/EvaDoleisch_foto.f02923ae.jpg";